"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBillingSummary = void 0;
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var calculator = __importStar(require("@CommonFrontendBackend/Quote/Calculator"));
var getBillingSummary = function (_a) {
    var e_1, _b;
    var blocks = _a.blocks, currency = _a.currency, taxes = _a.taxes, variableService = _a.variableService, discountService = _a.discountService;
    var variables = variableService.getAllVariables();
    var variableResolver = Object.fromEntries(variables.map(function (variable) { return [variable.getId(), variable]; }));
    var quoteSummary = {
        priceContext: {
            discounts: [],
            taxes: [],
            taxExemptions: [],
        },
        blocks: [],
    };
    try {
        for (var blocks_1 = __values(blocks), blocks_1_1 = blocks_1.next(); !blocks_1_1.done; blocks_1_1 = blocks_1.next()) {
            var block = blocks_1_1.value;
            if (block.type !== BlockTypes_1.BlockType.Quote || block.settings.currency !== currency) {
                continue;
            }
            quoteSummary.blocks.push(calculator.v2Transformer(block, variableResolver));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (blocks_1_1 && !blocks_1_1.done && (_b = blocks_1.return)) _b.call(blocks_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var priceSummary = calculator.calculatePriceSummary(quoteSummary, {
        taxes: taxes.map(function (tax) { return ({ id: tax.id, name: tax.name, rate: tax.percent }); }),
        discounts: discountService.getAllLiveDiscounts().map(function (discount) { return ({
            id: discount.id,
            name: discount.name,
            amountType: discount.type === "percent" ? "percentage" : "flat",
            amount: discount.amount,
        }); }),
        currency: currency,
    });
    return {
        total: priceSummary.total,
        lineItems: calculator.getBillableLineItems({ quoteSummary: quoteSummary, priceSummary: priceSummary }),
    };
};
exports.getBillingSummary = getBillingSummary;
